import React from 'react'
import './Portfolio.css'
import IMG1 from '../../assets/projects1.PNG'
import IMG2 from '../../assets/projects2.PNG'
import IMG3 from '../../assets/projects3.PNG'
import IMG4 from '../../assets/projects4.PNG'



const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container portfolio__container">
        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG1} alt="" />
          </div>
          <h2>Red Parts</h2>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/ridoy113/red-parts-client.git" className='btn' target='-blank'>Client Code</a>
            <a href="https://github.com/ridoy113/red-parts-server.git" className='btn btn-primary' target='-blank'>Server Code</a>
            <a href="https://red-parts-942db.web.app/" className='btn' target='-blank'>Live Demo</a>

          </div>
        </article>


        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG2} alt="" />
          </div>
          <h2>Doctors Portal</h2>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/ridoy113/doctors-portal-client" className='btn' target='-blank'>Client Code</a>
            <a href="https://github.com/ridoy113/online-doctor-service" className='btn btn-primary' target='-blank'>Server Code</a>
            <a href="https://doctors-portal-d3686.web.app/" className='btn' target='-blank'>Live Demo</a>

          </div>
        </article>


        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG3} alt="" />
          </div>
          <h2>Online Book</h2>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/ridoy113/online-book-client.git" className='btn' target='-blank'>Client Code</a>
            <a href="https://github.com/ridoy113/online-book-server.git" className='btn btn-primary' target='-blank'>Server Code</a>
            <a href="https://earnest-basbousa-faab14.netlify.app/" className='btn' target='-blank'>Live Demo</a>

          </div>
        </article>


        <article className='portfolio__item'>
          <div className="portfolio__item-image">
            <img src={IMG4} alt="" />
          </div>
          <h2>Online Doctor Service</h2>
          <div className='portfolio__item-cta'>
            <a href="https://github.com/ridoy113/online-doctor-service.git" className='btn' target='-blank'>GitHub Code</a>
            <a href="https://online-doctor-service-bec9d.web.app/" className='btn btn-primary' target='-blank'>Live Demo</a>
          </div>
        </article>

      </div>
    </section>
  )
}

export default Portfolio